// In Next.js, this file would be called: app/providers.tsx
'use client';

import getQueryClient from '@hub/common/src/get-query-client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider as RollbarProvider } from '@rollbar/react';
import Rollbar, { type Configuration } from 'rollbar';
import checkIgnore from '@hub/common/src/checkIgnore';

export default function Providers({
  children,
  rollbarConfig
}: {
  children: React.ReactNode;
  rollbarConfig: Configuration;
}) {
  const queryClient = getQueryClient();

  const rollbar = new Rollbar({ ...rollbarConfig, checkIgnore });

  return (
    <RollbarProvider instance={rollbar}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </RollbarProvider>
  );
}
